const { api, helpers } = require("../../utils");
const { stored } = api.net.config;
const cafe = {
    default: {
        sp: {
            chrome: {
                sms: "chrome/runtime/sendMessage"
            },
            marioGGSearch: "mario/google/search",
            rankingUpdate: "views/ranking/update",
            ignoreList: "loadIgnoreList",
        },
        region: "Sài Gòn",
    },
    region: {
        keyword: "where am i right now",
        selector: "div.vk_sh.vk_bk",
    },
    sms: {
        windowId: "Không có cửa sổ ẩn danh nào đang bật cả!",
        socket: api.sms.socket,
        extension: api.sms.extension,
        invalid_inputs: api.sms.invalid_inputs,
    },
};
const hlog = helpers.html.log;
const df = cafe.default;

const region = async ({ state, dispatch, commit }) => {
    let p = new Promise(async (resolve) => {
        if (state.region) return resolve({ is_success: true, data: state.region });
        hlog.start("store.chrome.region", "start");
        let href = helpers.text.link.google.search(cafe.region.keyword);
        let port = {
            window: {
                name: "chrome.windows.create",
                req: {
                    url: "about:blank",
                    focused: true,
                    incognito: true,
                    state: "maximized",
                },
            },
            html: {
                name: "chrome.get.html",
                tab: { id: -1 },
                req: {
                    windowId: -1,
                    href,
                    find: cafe.region.selector,
                    isRemove: false,
                },
            },
            reactive: {
                name: "chrome.windows.update",
                req: {
                    windowId: state.runtime.windowId,
                    req: { focused: true }
                },
            },
            manifest: {
                name: "chrome.runtime.manifest",
                req: {
                    url: window.location.href,
                },
            },
        };
        if (state.runtime.tab.id === -1) {
            let res_manifest = await dispatch(df.sp.chrome.sms, port.manifest, { root: true });
            console.log("res_manifest", res_manifest);
            if (!res_manifest || !res_manifest.is_success) return resolve({ error: res_manifest.error });
            port.reactive.req.windowId = res_manifest.data.tab.windowId;
        };
        let res_window = await dispatch(df.sp.chrome.sms, port.window, { root: true });
        let res_reative = await dispatch(df.sp.chrome.sms, port.reactive, { root: true });
        console.log("res.window", res_window);
        console.log("res.reative", res_reative);
        if (!res_window || !res_window.is_success) return resolve({ error: res_window.error });
        if (!res_window.data) return resolve({ error: cafe.sms.extension.not_allow_incognito });
        if (!res_reative || !res_reative.is_success) return resolve({ error: res_reative.error });
        let wd = res_window.data || { tabs: [] };
        let tab = wd.tabs[0];
        if (!tab) return resolve({ error: cafe.sms.extension.not_allow_incognito });
        port.html.req.windowId = wd.id;
        port.html.tab.id = tab.id;
        let html;
        let txtRegion = df.region;
        let res_html = await dispatch(df.sp.chrome.sms, port.html, { root: true });
        console.log("res.html", res_html);
        if (res_html.data && res_html.data.html) {
            html = res_html.data.html;
            let res_region = await api.node.cross.mario.google.region({ html });
            console.log("res.region", res_region);
            if (res_region && res_region.is_success) txtRegion = res_region.data.region;
        };
        let data = { region: txtRegion, windowId: wd.id };
        let { from } = state.runtime;
        from.region = data;
        commit({ type: "loadData", data: { region: data } });
        commit("runtime/loadData", { data: { from } });
        hlog.end("store.chrome.region", "end");
        resolve({ is_success: true, data });
    });

    return p;
};

const search = async ({ rootState, state, dispatch, commit }, payload) => {
    let p = new Promise(async (resolve) => {
        if (typeof (payload) !== "object") return resolve({ error: cafe.sms.invalid_inputs });
        let { keyword, windowId, listHostName } = payload;
        if (!keyword || !windowId || windowId === -1) return resolve({ error: cafe.sms.invalid_inputs });
        let socket = rootState.socket.socket;
        if (!socket || !socket.id) return resolve({ error: cafe.sms.socket.undefined });
        hlog.start("local.chrome.search", "start", keyword);
        listHostName = listHostName || [];
        let req = {
            windowId,
            href: `https://www.google.com/search?q=${keyword}&sourceid=chrome&ie=UTF-8`,
            find: "#search",
            isActive: true,
            isRemove: false,
        };
        let port = { name: "chrome.get.html", req };
        let res_html = await dispatch(df.sp.chrome.sms, port, { root: true });
        console.log("res.html", res_html);
        if (!res_html || !res_html.is_success) return resolve({ error: res_html.error });
        let { html } = res_html.data;
        let res_ranking = await dispatch(df.sp.marioGGSearch, { html }, { root: true });
        console.log("res.ranking", res_ranking);
        if (!res_ranking || !res_ranking.is_success) return resolve({ error: res_ranking.error });
        let { ranking, related } = res_ranking.data;
        let dHandle = handleRanking({ ranking, listHostName });
        let item = Object.assign({ id: socket.id, keyword, related }, dHandle);
        hlog.end("local.chrome.search", "end", item);
        dispatch(df.sp.rankingUpdate, Object.assign({ region: state.region }, item), { root: true });
        commit({ type: "loadSearch", item });
        resolve({ is_success: true, data: item });
    });

    return p;
};

const receiveSearch = async ({ commit }, payload) => {
    let p = new Promise(async (resolve) => {
        if (!payload || !payload.payload) return resolve({ error: cafe.sms.invalid_inputs });
        let res = payload.payload;
        hlog.start("store.search", "receive", res);
        if (!res.is_success) {
            commit({ type: "loadError", data: payload });
            resolve({ error: res.error });
            return;
        };
        let item = Object.assign(res.data, { id: payload.from.id });
        commit({ type: "loadSearch", item });
        resolve({ is_success: true, data: payload });
    });

    return p;
};

const handleRanking = ({ ranking, listHostName }) => {
    let data = { ranking: [], listHostName };
    if (!Array.isArray(ranking) || !Array.isArray(listHostName)) return data;
    for (let item of ranking) {
        let url = new URL(item.href);
        // let hn = url.hostname.replace("www.", "");
        // if (ignoreList.includes(hn)) continue;
        item.hostname = url.hostname;
        if (!data.listHostName.includes(item.hostname)) data.listHostName.push(item.hostname);
        data.ranking.push(item);
    }
    return data;
};

const loadIgnoreList = async ({ commit }) => {
    let p = new Promise(async (resolve) => {
        hlog.start("store.chrome.load.ignore.list", "start");
        let res_ignore = await api.net.data.bot.load.list({ storeName: stored.link.ahrefs.GetDomainIgnore, filter: {} });
        if (!res_ignore || !res_ignore.isSuccess) return resolve({ error: res_ignore.error });
        let ignoreList = [];
        for (let item of res_ignore.data) {
            const { ProjectHost } = item;
            if (!ignoreList.includes(ProjectHost)) ignoreList.push(ProjectHost);
        };
        let res = { isSuccess: true, data: ignoreList };
        hlog.end("store.chrome.load.ignore.list", "end", ignoreList.length);
        commit({ type: "loadData", data: { ignoreList } });
        resolve(res);
    });

    return p;
};

const removeWindow = async ({ state, dispatch }) => {
    let p = new Promise(async (resolve) => {
        const { region } = state;
        if (!region || region.windowId <= 0) return resolve({ error: cafe.sms.windowId });
        let req = { windowId: region.windowId };
        let port = { name: "chrome.windows.remove", req };
        hlog.start("local.chrome.window.remove", "start", req.windowId);
        let res_remove = await dispatch(df.sp.chrome.sms, port, { root: true });
        hlog.end("local.chrome.window.remove", "end", res_remove);
        resolve(res_remove);
    });

    return p;
};

export default {
    region,
    search,
    receiveSearch,
    loadIgnoreList,
    removeWindow,
};



// WEBPACK FOOTER //
// src/store/chrome/actions.js